import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, FolderSync, UserCheck } from 'lucide-react';
import { siteData } from '../data/mock';

const iconMap = {
  ShoppingBag,
  FolderSync,
  UserCheck,
};

const Transformations = () => {
  const { transformations } = siteData;

  return (
    <section className="py-20 md:py-32">
      <div className="container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--accent-text)] text-sm font-medium mb-4">
            Real-World Impact
          </span>
          <h2 className="heading-2 mb-4">
            How We Transform Businesses
          </h2>
          <p className="body-large">
            See how our AI-first approach delivers measurable results across industries.
          </p>
        </motion.div>

        {/* Transformation Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {transformations.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative bg-white rounded-2xl p-8 border border-black/10 hover:border-[var(--accent-primary)] hover:shadow-xl transition-all duration-300 group"
              >
                {/* Sector Badge */}
                <div className="absolute -top-3 left-6">
                  <span className="inline-block px-3 py-1 rounded-full bg-[var(--text-primary)] text-white text-xs font-semibold">
                    {item.sector}
                  </span>
                </div>

                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[var(--accent-primary)] to-[var(--accent-strong)] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-8 h-8 text-[var(--text-primary)]" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-[var(--text-primary)] mb-3">
                  {item.title}
                </h3>
                <p className="text-[var(--text-secondary)] leading-relaxed">
                  {item.description}
                </p>

                {/* Decorative element */}
                <div className="absolute bottom-0 right-0 w-24 h-24 bg-[var(--accent-wash)] rounded-tl-[60px] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Transformations;
